// @import

import { ensureHTMLElement } from "@src/js/lib/ensure";
import Alpine from "alpinejs";
import "vidstack/player";
import "vidstack/player/layouts/default";
import "vidstack/player/ui";

Alpine.directive("player", async (element, { expression }, { cleanup }) => {
  const player = element.querySelector("media-player");

  const errorDiv = document.createElement("div");
  errorDiv.classList.add("c-player__error");
  errorDiv.setAttribute("data-hidden", "");

  player?.subscribe((state) => {
    if (state.error) {
      errorDiv.textContent = state.error?.message || "An unknown error occurred.";
      element.appendChild(errorDiv);
    }
  });

  const dom = {
    mount: ensureHTMLElement(element.querySelector(".c-player__mount")),
    play: element.querySelector(".c-player__play-btn"),
    pause: element.querySelector(".c-player__pause-btn"),
  };

  // Fix poster visibility after loading on iOS see : https://github.com/vidstack/player/issues/1752
  const poster = element.querySelector("media-poster");
  if (poster) {
    poster.subscribe((state) => {
      if (state.loading === false && !state.error && state.src) {
        poster.removeAttribute("data-hidden");
        poster.removeAttribute("display");
        poster.setAttribute("data-visible", "");
        poster.querySelector("img")?.removeAttribute("style");
      }
    });
  }

  function triggerPause() {
    player?.pause();
  }

  function triggerPlay() {
    player?.play();
  }

  dom.play?.addEventListener("click", triggerPlay);
  dom.pause?.addEventListener("click", triggerPause);

  cleanup(() => {
    dom.play?.removeEventListener("click", triggerPlay);
    dom.pause?.removeEventListener("click", triggerPause);
  });
});
